import { render, staticRenderFns } from "./AppAnalysisPieCharts.vue?vue&type=template&id=2464aff8&scoped=true&"
import script from "./AppAnalysisPieCharts.vue?vue&type=script&lang=js&"
export * from "./AppAnalysisPieCharts.vue?vue&type=script&lang=js&"
import style0 from "./AppAnalysisPieCharts.vue?vue&type=style&index=0&id=2464aff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464aff8",
  null
  
)

export default component.exports